import { Campaign } from './Campaign';
import { Period } from './Period';

export interface CampaignsOverview {
  periods: Period[];
  campaigns: Campaign[];
}
